import {APIRegistry} from '@spothero/utils/api';
import Config from 'config';
import SegmentUtils from 'utils/segment';

const FacilityAPI = {
    getRecommendedSpots(data) {
        const searchAPIUtils = APIRegistry.get('ratesSearch');
        let ratesUrl = `facilities/rates/`;

        if (data.monthly) {
            ratesUrl += 'monthly/';
            delete data.monthly;
        }

        return searchAPIUtils.get(ratesUrl, data);
    },

    getRates({
        spotId,
        starts,
        ends,
        eventId = null,
        monthly = false,
        airport = false,
        includeFacility = true,
        vehicleInfoId = null,
        vehicleProfileId = null,
    }) {
        const searchAPIUtils = APIRegistry.get('ratesSearch');
        const includes = monthly ? 'monthly' : 'transient';
        const allIncludes = includeFacility
            ? `${includes},${Config.facilityIncludes}`
            : includes;
        const segmentId = SegmentUtils.getAnonymousId();
        const data = {
            starts,
            include: allIncludes,
            ...(segmentId && {
                segment_id: segmentId, // eslint-disable-line camelcase
                mixpanel_id: segmentId, // eslint-disable-line camelcase
            }),
            ...(ends && {ends}),
            ...(vehicleInfoId && {vehicle_info_id: vehicleInfoId}), // eslint-disable-line camelcase
            ...(vehicleProfileId && {vehicle_profile_id: vehicleProfileId}), // eslint-disable-line camelcase
            ...(eventId && {eid: eventId}),
        };
        let ratesUrl = `facilities/${spotId}/rates/`;

        if (monthly) {
            ratesUrl += 'monthly/';
        } else if (airport) {
            ratesUrl += 'airport/';
        }

        return searchAPIUtils.get(ratesUrl, data);
    },
};

export default FacilityAPI;
